import { render, staticRenderFns } from "./Habitacao.vue?vue&type=template&id=fc43279c"
import script from "./Habitacao.vue?vue&type=script&lang=js"
export * from "./Habitacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports